<template>
  <div class="main">
    <div class="content">
      <div class="header">
        <div class="header_quality">{{supervisionTaskData.companyName}}</div>
        <div class="header_foot">
          <div class="quality">
            品质指数评分完成，最新得分：
            <span class="score">{{supervisionTaskData.qualityScore}}分</span>
          </div>
          <div class="header_right" @click="toScoreDetails">查看详情></div>
        </div>
      </div>
      <div class="header_two"></div>
      <div class="content_view">
        <div class="content_text">
          <div class="content_text-header">
            <span>备注说明</span>
            <span>*</span>
          </div>
          <div class="content_text-center">
             <cell-group>
                <van-field
                  v-model="remack"
                  rows="3"
                  autosize
                  type="textarea"
                  maxlength="100"
                  placeholder="请在这里补充备注说明"
                  show-word-limit
                />
            </cell-group>
          </div>
        </div>
        <div class="content_text">
          <upload :imgUrl="imgUrl" :fileSource='1' :fileBizType='6'></upload>
        </div>
      </div>
      <div class="content_bottom">
        <div class="content_btn" @click="submitBtn">提交</div>
      </div>
    </div>
  </div>
</template>
<script>
    import api from '../../../../service/modules/integrity';
    import Upload from '../../components/Upload'
    export default {
        components: {
            Upload
        },
        data () {
            return {
                imgUrl: [],
                supervisionTaskData: {},
                remack: '',
                enterpriseId: this.$route.query.enterpriseId, // 企业ID
                supervisionId: this.$route.query.supervisionId // 企业监管ID
            };
        },
        created () {
            this.handleList();
        },
        mounted () {
            this.$on('fileUploadData', val => {
                this.imgUrl = val
            })
        },
        methods: {
            handleList () {
                api.supervisionTaskInfo({ enterpriseId: this.enterpriseId })
                    .then(res => {
                        if (res.ret === 0) {
                            this.supervisionTaskData = res.data;
                        }
                    });
            },
            toScoreDetails () {
                this.$router.push({
                    path: 'ScoreDetails',
                    query: {
                        id: this.supervisionTaskData.enterpriseId
                    }
                });
            },
            submitBtn () {
                if (this.remack === '' || this.imgUrl === '') {
                    this.remack += '.'
                    this.remack = ''
                    this.$Toast({
                        duration: 2000,
                        message: '请正确填写资料',
                        forbidClick: true
                    })
                } else {
                    let attachs = [...this.imgUrl];
                    if (attachs) {
                        attachs.map(item => { delete item.url })
                    }

                    let parm = {
                        mark: this.remack,
                        attach: JSON.stringify(attachs),
                        supervisionId: this.supervisionId
                    };
                    api.enterBlackList(parm).then(res => {
                        if (res.ret === 0) {
                            this.$router.push({ path: 'scoreDetails', query: { id: this.enterpriseId, name: 'blakList' } })
                        }
                    });
                }
            }
        }
    };
</script>
<style lang="less" scoped>
.main {
  background: #eee;
  width: 100%;
  height: 100vh;
  .content {
    background: #fff;
    height: 100%;
    .header {
      padding: 16px 12px 0 12px;
      overflow: hidden;
      .quality {
        float: left;
        width: 70%;
        font-size: 14px;
        line-height: 24px;
        .score {
          color: red;
        }
      }
      .header_quality {
        font-size: 14px;
        line-height: 24px;
        font-weight: 700;
      }
      .header_foot {
        overflow: hidden;
      }
      .header_left {
        float: left;
        width: 75%;
        .header_left_time {
          font-size: 12px;
          line-height: 30px;
        }
        .lawEnforcement {
          line-height: 18px;
          font-size: 12px;
        }
      }
      .header_right {
        margin-top: 6px;
        float: right;
        width: 20%;
        color: #36b374;
      }
      .content_area {
        border-radius: 6px;
      }
    }
      .header_two{
        margin-top: 20px;
        background-color: #eeeeee;
        height: 5px;
        width: 100%;
    }
    .content_view {
      .content_text {
        padding: 16px;
        .content_text-header {
          padding: 16px 0;
          span:nth-child(1) {
            font-size: 14px;
          }
          span:nth-child(2) {
            color: red;
          }
        }
        .content_text-center {
          width: 100%;
        }
        .content_text-up {
          padding: 20px 0;
        }
      }
    }
    .content_bottom {
      width: 100%;
      height: 50px;
      background: #fff;
      position: fixed;
      bottom: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      .content_btn {
        background: #36b374;
        color: #fff;
        font-size: 14px;
        height: 40px;
        width: 93%;
        border-radius: 5px;
        text-align: center;
        line-height: 40px;
      }
    }
  }
}
</style>
